<template>
  <div class="paragraphs__list">
    <template v-if="isLoading">
      <div class="d-flex flex-column justify-content-center text-center align-items-center app__loading">
        <p><strong>Loading data...</strong></p>
        <b-spinner></b-spinner>
      </div>
    </template>
    <template v-else>
      <draggable
        v-model="paragraphs"
        v-bind="paragraphsDragOptions"
        handle=".paragraph__drag-handle"
        @start="isDragging = true"
        @end="isDragging = false"
        @change="paragraphsOrderChange($event)"
      >
        <transition-group type="transition" :name="!isDragging ? 'flip-list' : null">
          <MonitorParagraph
            v-for="(paragraph, index) in paragraphs"
            :paragraph="paragraph"
            :key="paragraph.id"
            :index="index"
            @requestParagraphEdit="requestParagraphEdit(paragraph)"
            @requestParagraphDelete="requestParagraphDelete(paragraph)"
            @paragraphDuplicated="getParagraphs()"
          />
        </transition-group>
      </draggable>
    </template>

    <b-modal
      id="bv-modal-delete-paragraph"
      size="lg"
      centered
      @ok="deleteParagraph"
    >
      <template v-slot:modal-title>
        Move to Trash
      </template>
      <p>Are you sure you want to move {{ paragraphToDelete.name }} paragraph to the trash?</p>
      <b-alert variant="warning" show>
        <strong>WARNING: This action will update and delete this object also in the User Dashboard.</strong><br>
        Are you sure you want to proceed?
      </b-alert>
    </b-modal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

import MonitorParagraph from "./MonitorParagraph";

import {
  MONITOR_PARAGRAPH_GET_ALL,
  MONITOR_PARAGRAPH_EDIT,
  MONITOR_PARAGRAPH_DELETE
} from "@/store/actions.type";

import {
  STATE_MONITORS_CURRENT_PARAGRAPHS_SET,
  STATE_MONITORS_STRUCTURE_PARAGRAPHS_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorParagraphList',
  props: ['monitorId', 'chapterId', 'updateList'],
  components: {
    draggable,
    MonitorParagraph
  },
  data() {
    return {
      isLoading: true,
      isDragging: false,
      paragraphs: [],
      paragraphToDelete: {}
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCategory", "monitorCurrent"]),
    paragraphsDragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "paragraph__drag-ghost"
      };
    }
  },
  methods: {
    async getParagraphs() {
      this.isLoading = true;
      await this.$store.dispatch(MONITOR_PARAGRAPH_GET_ALL, this.chapterId).then((data) => {
        this.paragraphs = data;
        this.$store.commit(STATE_MONITORS_CURRENT_PARAGRAPHS_SET, this.paragraphs);
        this.returnParagraphs();  
      });
      this.isLoading = false;
    },
    // chapterStatusClasses(chapter) {
    //   return {
    //     'chapter__status': true,
    //     'chapter__status--draft': chapter.is_online === false,
    //     'chapter__status--empty': chapter.number_of_objects === 0, 
    //     'chapter__status--published': chapter.is_online === true
    //   }
    // },
    returnParagraphs() {
      this.$emit('paragraphsFetched', this.paragraphs);
    },
    paragraphsOrderChange(event) {
      let newOrder = parseInt(event.moved.newIndex) + 1;
      let paragraphId = event.moved.element.id;

      let paragraphData = new FormData();
      paragraphData.set('order', newOrder);

      let payload = {
        chapterId: this.chapterId,
        paragraphId: paragraphId,
        paragraphData: paragraphData
      }

      this.$store.dispatch(MONITOR_PARAGRAPH_EDIT, payload).then(() => {
        this.$bvToast.toast(`Paragraphs order has been updated successfully`, {
          title: 'Paragraphs update',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.isLoading = false;
        let paragraphsStructure = {
          chapterId: this.chapterId,
          paragraphs: this.paragraphs
        }
        this.$store.commit(STATE_MONITORS_STRUCTURE_PARAGRAPHS_SET, paragraphsStructure);
        this.getParagraphs();
      });
    },
    requestParagraphEdit(paragraph) {
      this.$emit('requestParagraphEdit', paragraph);
    },
    requestParagraphDelete(paragraph) {
      this.paragraphToDelete =  Object.assign({}, paragraph);
      this.$bvModal.show('bv-modal-delete-paragraph');
    },
    deleteParagraph() {
      this.isLoading = true;
      let payload = {
        chapterId: this.chapterId,
        paragraphId: this.paragraphToDelete.id
      }
      this.$store.dispatch(MONITOR_PARAGRAPH_DELETE, payload).then(() => {
        this.$bvToast.toast(`Paragraph ${this.paragraphToDelete.name} has been moved to trash successfully`, {
          title: 'Paragraph moved to trash',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.paragraphToDelete = {};
        this.getParagraphs();
        this.isLoading = false;
      });
    },
    // setCurrentChapter(chapter) {
    //   this.$store.commit(STATE_MONITORS_CURRENT_CHAPTER_SET, chapter);
    // }
  },
  mounted() {

    // this.getParagraphs();

  },
  watch: {
    monitorId: function() {
      this.getParagraphs();
    },
    updateList: function(newValue) {
      if(newValue === true) {
        this.getParagraphs();
      }
    },
    paragraphs: function() {
      // simuliamo fetch anche se è solo un reorder
      this.$emit('paragraphsFetched', this.paragraphs);
      // this.$store.commit(STATE_MONITORS_STRUCTURE_PARAGRAPHS_SET, this.paragraphs);
    }
  }
}
</script>

<style lang="scss">
.paragraph {
  position: relative;

  &__status {
    position: absolute;
    left: 0;
    top: 0;
    width: rem(10px);
    height: 100%;
    border-top-left-radius: rem(8px);
    border-bottom-left-radius: rem(8px);

    &--draft {
      background-color: $color-sunset;
    }

    &--empty {
      background-color: $color-abbey;
    }

    &--published {
      background-color: $color-genoa;
    }
  }

  &__drag-handle {

    svg {
      width: rem(20px);
      height: rem(20px);
    }

    &:hover {
      cursor: move;
    }
  }

  &__drag-ghost {
    opacity: 0.5;
  }

  &__title {
    color: $color-abbey;
    font-weight: 700;
    margin-bottom: rem(8px);
  }

  &__action {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill: $color-java;
      }
    }
  }
}
</style>